module.exports = __webpack_public_path__ + "img/mikeonrecord.0767b0aa.jpg";